/**
 * Get a duplicate name by adding a number in parentheses at the end of the name.
 * @param name Name
 * @return Duplicate name
 *
 * @example
 * ```ts
 * const duplicateName = getDuplicateName('name'); // name (1)
 * const duplicateName = getDuplicateName('name (1)'); // name (2)
 * const duplicateName = getDuplicateName('name (1) (1)'); // name (1) (2)
 * ```
 */
export const getDuplicateName = (name?: string) => {
	if (!name) return '';
	const m = name.match(/.*(\(\d+\))$/);
	if (m === null) return `${name} (1)`; // no match, so this is the first duplicate
	return `${name.slice(0, -m[1].length)}(${
		parseInt(m[1].slice(1, -1), 10) + 1
	})`;
};

export default getDuplicateName;
